export enum SupportedLanguages {
  EN = 'en',
  NO = 'no',
}

export type LocalizedField<P extends string> = {
  [K in SupportedLanguages as `${P}_${string & K}`]: string;
};
